import { useEffect, useState, useRef } from "react";
import PlayerList from "../playerList/PlayerList";
import { apiHandler } from "../../assets/api";
import { useSelector } from "react-redux";
import { endpoint } from "../../assets/api/endpoint";
import GameSearchFilter from "../gamesearchfilter/GameSearchFilter";
import { HashLoader } from "react-spinners";
import { IoMdSearch } from "react-icons/io";
import FilterImg from '../../assets/icons/Filter.png';
import { MdOutlineSportsTennis } from "react-icons/md";


const Stringer = () => {
  const { accessToken ,filterUpdating} = useSelector((state) => state.loginInfo);
  const [stringerPlayer, setStringerPlayer] = useState([]);
  const [cancelFilter, setCancelFilter] = useState(true);
  const [loader, setLoader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const modalRef = useRef(null);
  const [sportName, setSportName] = useState("");

  useEffect(() => {
    const OnStringer = async () => {
      setLoader(true);
      try {
        const response = await apiHandler({
          url: `${endpoint?.fetchAllStringerPlayer}`,
          method: "GET",
          authToken: accessToken?.accessToken,
        });

        if (response?.data && !response?.data?.error_description) {
          setLoader(false);
          setStringerPlayer(response?.data);
          // toast.success("");
        } else {
          setLoader(false);
          // toast.error(response?.data?.error_description);
        }
      } catch (error) {
        setLoader(false);
        console.error("Error deleting account:", error);
      }
    };
    OnStringer();
  }, [cancelFilter,filterUpdating,accessToken]);
 

  const closeModal = (data) => {
    setCancelFilter(!cancelFilter)
  }
  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  const onCloseFilterModal = (data) => {
    setIsOpen(!data);
    closeModal(data);
  }

  const filteredStringerPlayer = stringerPlayer?.filter(player =>
    player.name?.toLowerCase().includes(searchQuery.toLowerCase())
  ) || [];

  const onCloseModal = () => {
    setIsOpen(false);
  }

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      toggleModal();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const onSelectedSport = (sportName) => {
    setSportName(sportName)
  }

  return (
    <>
      {!loader ?
        <div style={{ background: '#F8F8F8', width: '100%', minHeight: '80vh' }}>
          <div className="container mt-2 p-3 p-sm-0">
            <div className="d-sm-flex justify-content-between align-items-center">
              <div className="d-flex justify-content-between align-items-center p-2 stringer-text-wrapper w-100" style={{ width: '66%'}}>
                <h4 className="mb-2 mb-sm-0 ps-sm-2">Stringers Around You</h4>
               {sportName && <h6 style={{ color: 'rgb(31, 32, 36)' , fontWeight: '700', fontSize: '15px' }}> <MdOutlineSportsTennis className="fs-6"/> {sportName}</h6>}
              </div>
              <div className="d-flex justify-content-end align-items-center p-2 mb-2 mb-sm-0 ">
                <div className="d-flex justify-content-between player-list-search-bar w-100">
                  <div className="search-bar d-flex justify-content-end">
                    <IoMdSearch className="fs-2 me-2" />
                    <input
                      type="text"
                      placeholder="Search Players..."
                      className="search-input"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                  <div>
                    <img src={FilterImg} onClick={toggleModal} style={{ cursor: 'pointer' }} />
                  </div>
                </div>
              </div>
            </div>
            <div className=" h-100">
              {stringerPlayer?.length > 0 ?
                <PlayerList stringerPlayer={filteredStringerPlayer} closeModal={closeModal} />
                :
                <div className="d-flex justify-content-center align-items-center mt-3" style={{ height: '59vh' }}>
                  <h3 className="" style={{ fontWeight: '600', color: 'rgba(33, 37, 41, 0.75)' }}>Stringer Players Are Not Available</h3>
                </div>
              }
              <div>
                <div className={`modal-overlay ${isOpen ? 'open' : 'closeModal'}`}>
                  <div ref={modalRef} className="modal-content overflow-x-auto">
                    <GameSearchFilter
                      onCloseFilterModal={onCloseFilterModal}
                      onCloseModal={onCloseModal}
                      onSelectedSport={onSelectedSport}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        :
        <div className="d-flex align-items-center justify-content-center" style={{ height: '75vh' }}>
          < HashLoader color="#e48181" />
        </div>
      }
    </>
  )
}
export default Stringer;